import { version } from '../../package.json';


//See EnvConfigurationService for dynamic configuration
export const environment = {
  production: true,
  version: version,
  apiBaseUrl: 'https://bibnetads-prod.michelin.com/b2c/api/patsac'
};
